export const NEW_CUSTOMER_COUPON_JSON_EPPO_ID = 'web-2425-new-customer-coupon-json';
export const NEW_CUSTOMER_COUPON_JSON_EPPO_JSON_PARAMS = {
  modalTitle: 'string',
  title: 'string',
  description: 'string',
  tncText: 'string',
  tncLink: 'string',
  btnText: 'string',
  authModalTitle: 'string',
  promo: 'string',
  bannerTitle: 'string',
  image: 'string',
};

export const SHOW_LOGIN_MODAL_ON_UBR_PAGE_LOAD_EPPO_ID = 'web-2604-ubr-show-login-on-page-load';
export const SHOW_LOGIN_MODAL_ON_UBR_PAGE_LOAD_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const CREATE_MOBILE_APP_BANNER_EPPO_ID = 'web-2715-create-mobile-app-banner';
export const CREATE_MOBILE_APP_BANNER_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID =
  'web-2721-set-weekly-as-the-default-option-for-rwb';
export const SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const PEAK_PERIOD_PAGE_WEB_EPPO_ID = 'web-2794-peak-period-page-web';
export const PEAK_PERIOD_PAGE_WEB_EPPO_JSON_PARAMS = {
  title: 'string',
  description: 'string',
  dates: 'object',
  name: 'string',
};
